import type { RoleRejectionEvidenceView } from "@actale/contracts";
import { useState } from "react";
import { api, ApiError } from "./api.js";

export function RoleRejectionEvidence({ invocationId, isDirector = false }: { invocationId: string; isDirector?: boolean }): React.ReactNode {
  const [evidence, setEvidence] = useState<RoleRejectionEvidenceView | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  async function load() {
    setLoading(true); setError("");
    try { setEvidence(await api.roleRejectionEvidence(invocationId)); }
    catch (caught) { setError(caught instanceof ApiError ? caught.message : "无法读取失败证据"); }
    finally { setLoading(false); }
  }
  return <div className="role-rejection-evidence">
    <button className="secondary-button compact" disabled={loading} onClick={() => evidence ? setEvidence(null) : void load()}>
      {loading ? "读取中…" : evidence ? "收起失败证据" : isDirector ? "查看被拦的导演指令" : "查看被拦的角色回复"}
    </button>
    {error ? <p role="alert">{error}</p> : null}
    {evidence ? <div>
      <p>仅超级管理员可见，可能含角色秘密；不是玩家实际收到的消息。</p>
      <p>角色：{evidence.speakerName}（{evidence.speakerKey}） · 检查：{evidence.errorCode}</p>
      {evidence.rejectionCause ? <p>具体原因：{evidence.rejectionCause}</p> : null}
      {evidence.match ? <p>触发方式：{{ KNOWLEDGE_KEY: "出现受保护的知识编号", FACT_FRAGMENT: "与受保护知识有相同文字", TIME_MARKER: "出现受保护的时间片段" }[evidence.match.kind]}。命中{evidence.match.channel === "performanceBrief" ? "表演指令" : evidence.match.channel === "actionText" ? "动作" : evidence.match.channel === "speechText" ? "台词" : "动作与台词拼接处"}：“{evidence.match.fragment}”；知识项：{evidence.match.knowledgeKey}。</p> : null}
      {evidence.stage === "DIRECTOR_PLAN" ? <>
        <p><strong>导演表演指令</strong><br />{evidence.performanceBrief || "（无）"}</p>
        {evidence.actionText ? <p><strong>导演动作说明</strong><br />{evidence.actionText}</p> : null}
      </> : <>
        <p><strong>动作</strong><br />{evidence.actionText || "（无）"}</p>
        <p><strong>台词</strong><br />{evidence.speechText || "（无）"}</p>
      </>}
      {evidence.truncated ? <p>回复过长，仅保留每栏前 4000 字；不能视为完整原文。</p> : null}
      <small>命中检查不等于已确认违规，仍需结合当时现场人工复核。</small>
    </div> : null}
  </div>;
}
